import { appConst } from "../AppConst";

/**
 * Đánh giá độ mạnh mật khẩu phía client — KHỚP tiêu chí backend (Common/PasswordStrength.cs):
 *   - Độ dài >= PASSWORD_MIN_LENGTH (mirror backend PasswordPolicy:MinLength qua env).
 *   - Có >= 3 trong 4 nhóm ký tự: chữ thường, chữ HOA, số, ký tự đặc biệt.
 *   - Khác mã sinh viên.
 *
 * Đây chỉ là hint/UX — server mới là nơi chốt chặn (claim pwd_must_change + validate khi đổi).
 * minLength lấy từ appConst.passwordPolicy.minLength (REACT_APP_PASSWORD_MIN_LENGTH) để đồng bộ backend.
 */
export const PASSWORD_MIN_LENGTH = appConst.passwordPolicy.minLength;

export interface IPasswordCheck {
    key: string;
    label: string;
    passed: boolean;
}

export interface IPasswordStrengthResult {
    isStrong: boolean;
    checks: IPasswordCheck[];
    /** Số nhóm ký tự có mặt (0..4). */
    classCount: number;
}

export const evaluatePasswordStrength = (password: string, maSv?: string): IPasswordStrengthResult => {
    const pw = password || "";
    const hasLower = /[a-z]/.test(pw);
    const hasUpper = /[A-Z]/.test(pw);
    const hasDigit = /[0-9]/.test(pw);
    const hasSpecial = /[^a-zA-Z0-9]/.test(pw);
    const classCount = [hasLower, hasUpper, hasDigit, hasSpecial].filter(Boolean).length;

    const longEnough = pw.length >= PASSWORD_MIN_LENGTH;
    const enoughClasses = classCount >= 3;
    const notMaSv = !maSv || pw.trim().toLowerCase() !== maSv.trim().toLowerCase();

    const checks: IPasswordCheck[] = [
        { key: "length", label: `Ít nhất ${PASSWORD_MIN_LENGTH} ký tự`, passed: longEnough },
        {
            key: "classes",
            label: "Có ít nhất 3/4 nhóm: chữ thường, chữ HOA, số, ký tự đặc biệt",
            passed: enoughClasses,
        },
        { key: "notMaSv", label: "Khác mã sinh viên", passed: notMaSv },
    ];

    return { isStrong: longEnough && enoughClasses && notMaSv, checks, classCount };
};
